import { useEffect } from 'react'

/**
 * Shared overlay behaviour: Escape closes, body scroll locks while open.
 * Used by BottomSheet and Dialog. Internal design-system helper.
 */
export function useOverlayBehaviour(open: boolean, onClose: () => void): void {
  useEffect(() => {
    if (!open) return
    const handleKeyDown = (event: globalThis.KeyboardEvent) => {
      if (event.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [open, onClose])

  useEffect(() => {
    if (!open) return
    const previous = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = previous
    }
  }, [open])
}
